import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=102680c8&scoped=true&"
import script from "./ConfigForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigForm.vue?vue&type=style&index=0&id=102680c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102680c8",
  null
  
)

export default component.exports